module.exports = __webpack_public_path__ + "img/tpc-1.5d937b47.webp";